/**
 * Whether navigate(-1) lands on an earlier page of this app load.
 *
 * react-router numbers the history entries it owns (`state.idx`): 0 on a full
 * page load, +1 per push, unchanged by a replace. `location.key === 'default'`
 * is not a substitute: any replace on load (e.g. Routes.tsx lowercasing
 * `/Patient/...`) swaps in a random key, and going back from there reaches
 * whatever preceded the load, such as the pre-redirect URL of an email link
 * or the mail client itself.
 */
export const canGoBackInApp = (): boolean => (window.history.state?.idx ?? 0) > 0;
